import { inject, Injectable } from '@angular/core';
import { WindowService } from './window.service';

export function domainTransitionFactory(domainTransitionService: DomainTransitionService) {
    return () => domainTransitionService.redirectIfNeeded();
}

@Injectable({
    providedIn: 'root'
})
export class DomainTransitionService {
    private readonly oldDomain = 'viessmann.com';
    private readonly newDomain = 'viessmann-climatesolutions.com';

    private windowService = inject(WindowService);

    redirectIfNeeded(): void {
        const window = this.windowService.nativeWindow;
        const { href } = window.location;
        const url = new URL(href);
        if (url.hostname.includes(this.oldDomain)) {
            const newHref = url.toString().replace(this.oldDomain, this.newDomain);
            window.location.replace(newHref);
        }
    }
}
